import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';
import {
  UserInfo,
  ProductAdditionalQueryMap,
  UserPermissions,
} from '@/types/type';

export interface ILoginUserStore {
  _userInfo: UserInfo | undefined;
  productAdditionalQueryMap: ProductAdditionalQueryMap;
  permissions: UserPermissions | null;
}

@Module({
  dynamic: true,
  store,
  name: 'loginUserStore',
  namespaced: true,
})
export default class LoginUserStore extends VuexModule
  implements ILoginUserStore {
  public _userInfo: UserInfo | undefined = undefined;
  public productAdditionalQueryMap: ProductAdditionalQueryMap = {};
  public permissions: UserPermissions | null = null;

  @Mutation
  public clear() {
    this._userInfo = undefined;
    this.productAdditionalQueryMap = {};
    this.permissions = null;
  }

  @Mutation
  public setUserInfo(userInfo: UserInfo) {
    this._userInfo = userInfo;
  }

  @Mutation
  public setPermissions(permissions: UserPermissions) {
    this.permissions = permissions;
  }

  public get isLoaded(): boolean {
    return !!this._userInfo;
  }

  public get isPermissionsLoaded(): boolean {
    return !!this.permissions;
  }

  public get userInfo(): UserInfo {
    return this._userInfo
      ? this._userInfo
      : {
          isAdmin: false,
          language: 'ja',
          userName: 'No Name',
          affiliationName: 'No Data',
          useFavoritePanel: false,
          canUseCsr: false,
          canUseCws: false,
          canUseCjk: false,
          canUseCtm: false,
        };
  }

  public get userPermissions(): UserPermissions | null {
    return this.permissions;
  }

  @Mutation
  public setProductAdditionalQueryMap(
    productAdditionalQueryMap: ProductAdditionalQueryMap
  ) {
    this.productAdditionalQueryMap = productAdditionalQueryMap;
  }
}

export const loginUserModule = getModule(LoginUserStore);
